import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {_} from '../../../utils/i18n';

const HelpText = _("Use the slider to adjust the circle's position.");

class Relation extends Component {

    static canContinue(answer, config) {
        const {answer_optional: isAnswerOptional} = config;
        if (isAnswerOptional) {
            return false;
        }

        return !Boolean(answer && typeof answer.value === 'number');
    }

    render() {
        const {config, answer} = this.props;
        const {value = 0} = answer;

        return (
            <div className="relation-block">
                <svg viewBox="0  0 520 120">
                    <filter x="0" y="0" width="1" height="1" id="removebackground">
                        <feComposite in="SourceGraphic"/>
                    </filter>

                    <circle cx={60 + (value * 2)} cy="60" r="60" />
                    <circle cx={460 - (value * 2)} cy="60" r="60" />

                    <text
                        className="text-3xl"
                        alignmentBaseline="central"
                        textAnchor="middle"
                        x={60 + (value * 2)}
                        y="35"
                        filter="url(#removebackground)"
                    >
                        {config.labelLeft}
                    </text>

                    <text
                        className="text-2xl"
                        alignmentBaseline="central"
                        textAnchor="middle"
                        lengthAdjust="spacing"
                        x={460 - (value * 2)}
                        y="75"
                        filter="url(#removebackground)"
                    >
                        {config.labelRight}
                    </text>
                </svg>
                <p className="range-field">
                    <input type="range" min="0" max="100" value={value} onChange={this.onChange} id="lesson-block-relation" />
                    <label htmlFor="lesson-block-relation">{HelpText}</label>
                </p>
            </div>
        );
    }

    onChange = event => {
        const {updateAnswer} = this.props;
        const value = +event.currentTarget.value;
        updateAnswer({value});
    };
}

Relation.propTypes = {
    config: PropTypes.shape({
        labelLeft: PropTypes.string.isRequired,
        labelRight: PropTypes.string.isRequired,
    }).isRequired,
    answer: PropTypes.shape({
        value: PropTypes.number,
    }).isRequired,
    updateAnswer: PropTypes.func.isRequired,
};

export default Relation;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Relation.js